import React, { useState, useEffect } from 'react';
import AddRaza from './AddRaza';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionRazas() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [razas, setRazas] = useState([]);
    const [editRaza, setEditRaza] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [razaToDelete, setRazaToDelete] = useState(null);
    const { user } = useUser();

    const fetchRazas = async () => {
        try {
            const response = await fetch(`${server}/MgRazas`);
            const data = await response.json();
            setRazas(data.$values);
        } catch (error) {
            console.error('Error al cargar las razas:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las razas: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchRazas();
    }, []);

    const handleNewRaza = () => {
        fetchRazas();
        setEditRaza(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (raza) => {
        setRazaToDelete(raza);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setRazaToDelete(null);
    };

    const handleDeleteRaza = async () => {
        if (razaToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';

                const response = await fetch(`${server}/MgRazas/${razaToDelete.id}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchRazas(); // Recargar la lista de razas
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Raza eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                console.error('Error al eliminar la raza:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar la raza: ' + error,
                });            }
        }
    };

    const filteredRazas = razas.filter(raza => raza.descripcion.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddRaza handleNewRaza={handleNewRaza} editRaza={editRaza} />
                <div className="ln_solid" />

                <h2>Razas Existentes</h2>

                <div className="row">
                    <div className="col-md-5 col-sm-4 offset-md-3">
                        <TextField
                            variant="outlined"
                            label="Buscar raza"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredRazas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((raza) => (
                                            <TableRow key={raza.id}>
                                                <TableCell component="th" scope="row">
                                                    {raza.descripcion}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditRaza(raza)} color="primary" disabled={!tienePermiso('Editar Raza')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(raza)} color="secondary" disabled={!tienePermiso('Eliminar Raza')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredRazas.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar la raza seleccionada?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={handleDeleteRaza} color="primary" autoFocus>
                                        Eliminar
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionRazas;
